const $ = jQuery;

export default class GeoRetailerMap {
    constructor(options = null) {
        this.map = null; // Define a class property for the map
        this.markers = []; // Initialize markers array at the class level
        this.AdvancedMarkerElement = null;
        this.PinElement = null;
        this.markerInfoMap = {};
        this.isLibrariesLoaded = false; // Add flag to track library loading
        // this.g = null;
        // this.__googleApi();
        this.__loadGoogleMapsLibrary();
    }

    async __loadGoogleMapsLibrary() {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

        // Assign the imported classes to the class properties
        this.Map = Map;
        this.AdvancedMarkerElement = AdvancedMarkerElement;
        this.PinElement = PinElement;
        this.isLibrariesLoaded = true; // Set flag to true

        // Initialize the map now that the libraries are loaded
        await this.__geoRetailerMap();
    }

    async init() {
        // Wait for libraries to be loaded before initializing markers
        if (!this.isLibrariesLoaded) {
            // Wait a bit and check again, or you could use a proper promise
            await new Promise((resolve) => {
                const checkLoaded = () => {
                    if (this.isLibrariesLoaded) {
                        resolve();
                    } else {
                        setTimeout(checkLoaded, 100);
                    }
                };
                checkLoaded();
            });
        }
        this.__geolocateMarkers();
    }

    async __geoRetailerMap() {
        const self = this; // tutor the current instance context

        const mapContainer = document.getElementById("geo-retailer-map");

        let lat = Number(mapContainer.getAttribute("data-lat"));
        let lng = Number(mapContainer.getAttribute("data-lng"));

        if (!lat && !lng) {
            //rouch central uk
            $lat = 53.9449837;
            $lng = -2.5260288;
        }

        async function initMap() {
            if (!document.getElementById("geo-retailer-map")) {
                return;
            }

            // Ensure the Map class is available
            if (!self.Map) {
                console.error("Google Maps Map class is not available");
                return;
            }

            // Swap this out for your current geo location, currect default is london
            const position = {
                lat: lat,
                lng: lng,
            };

            self.map = new self.Map(document.getElementById("geo-retailer-map"), {
                zoom: 12,
                center: position,
                mapId: "7f0bb468c0400fd750b4dd2c",
            });
        }
        await initMap(); // Make sure map is initialized

        document.body.addEventListener("click", (e) => {
            if (e.target.closest(".open-info-window")) {
                const markerId = e.target.closest(".open-info-window").dataset.markerId;
                if (markerId) {
                    this.__openInfoWindowById(markerId);
                } else {
                    console.error("No data-marker-id attribute found on clicked element.");
                }
            }
        });
    }

    __geolocateMarkers() {
        const self = this; // Capture the context of the class instance
        const coordinatesArray = [];
        const mapContainer = document.getElementById("geo-retailer-map");

        let startlat = Number(mapContainer.getAttribute("data-lat"));
        let startlng = Number(mapContainer.getAttribute("data-lng"));
        let tutorArray;

        tutorArray = JSON.parse(mapContainer.getAttribute("data-related-tutors"));

        const tutors = async () => {
            Object.entries(tutorArray).forEach(([key, tutor]) => {
                coordinatesArray.push({
                    lat: tutor.Latitude,
                    lng: tutor.Longitude,
                    title: tutor.Name,
                    id: tutor.ID,
                    distance: tutor.Distance,
                    permalink: tutor.permalink,
                });
            });
            coordinatesArray.reverse();

            let i = 0;

            const color = "#EA5152";

            let arrayCount = coordinatesArray.length;
            coordinatesArray.forEach((coordinate) => {
                const position = {
                    lat: parseFloat(coordinate.lat),
                    lng: parseFloat(coordinate.lng),
                };
                const title = coordinate.title;
                const id = coordinate.id;
                const distance = coordinate.distance;
                const permalink = coordinate.permalink;

                self.__createMarker(position, title, id, distance, startlat, startlng, color, permalink);
                i++;

                if (i === arrayCount) {
                    self.__mapMarkers();
                }
            });
        };

        tutors();

        self.__addStartingLocationPin(startlat, startlng);
    }

    __createMarker(position, title, id, distance, startlat, startlng, color = "#EA5152", permalink) {
        const urlParams = new URLSearchParams(window.location.search);
        const givenlat = urlParams.get("lat");
        const givenlng = urlParams.get("lng");

        let givenDistance = "";

        // Add safety check
        if (!this.AdvancedMarkerElement) {
            console.error("AdvancedMarkerElement is not loaded yet");
            return;
        }

        const map = this.map;
        const parser = new DOMParser();
        const pinSvgString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24.74" height="29.74" viewBox="0 0 24.74 29.74"><defs><filter id="Path_8501" x="0" y="0" width="24.74" height="29.74" filterUnits="userSpaceOnUse"><feOffset dy="1" input="SourceAlpha"/><feGaussianBlur stdDeviation="1" result="blur"/><feFlood flood-opacity="0.102"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter></defs><g id="Group_1224" data-name="Group 1224" transform="translate(17663 17147)"><g transform="matrix(1, 0, 0, 1, -17663, -17147)" filter="url(#Path_8501)"><path id="Path_8501-2" data-name="Path 8501" d="M124.023,54.728a9.37,9.37,0,0,0-9.37,9.37c0,7.182,9.37,14.371,9.37,14.371s9.37-7.189,9.37-14.371A9.37,9.37,0,0,0,124.023,54.728Z" transform="translate(-111.65 -52.73)" fill="#fff"/></g><path id="Path_8500" data-name="Path 8500" d="M124.023,54.728a9.37,9.37,0,0,0-9.37,9.37c0,7.182,9.37,14.371,9.37,14.371s9.37-7.189,9.37-14.371A9.37,9.37,0,0,0,124.023,54.728Zm0,13.847A4.477,4.477,0,1,1,128.5,64.1,4.477,4.477,0,0,1,124.023,68.575Z" transform="translate(-17774.652 -17199.729)" fill="var(--primary)" stroke="var(--primary)" stroke-width="0.1"/></g></svg>`;

        const pinSvg = parser.parseFromString(pinSvgString, "image/svg+xml").documentElement;

        const marker = new this.AdvancedMarkerElement({
            position,
            map,
            title,
            content: pinSvg,
        });
        this.markers.push(marker);

        if (givenlat && givenlng) {
            givenDistance = `<div class='distance'>${distance.toFixed(2)} Miles</div>`;
        }

        const infoWindow = new google.maps.InfoWindow({
            content:
                `<div class="tutor-name">${title}</div>` +
                `<div class='price-container d-flex justify-content-between align-items-start'>` +
                // `<span class='separater'>|</span>` +
                `<div>` +
                givenDistance +
                `</div>` +
                `</div>` +
                `<a href='${permalink}' target='_blank' class='link button button-default'>View Tutor</a>`,
        });

        marker.addListener("click", () => {
            // Close all other info windows
            Object.values(this.markerInfoMap).forEach(({ infoWindow }) => {
                if (infoWindow.getMap()) {
                    infoWindow.close();
                }
            });
            infoWindow.open(this.map, marker);
        });

        // tutor the marker and infoWindow in the map with the associated ID
        this.markerInfoMap[id] = { marker, infoWindow };
    }

    __mapMarkers() {
        const mapContainer = document.getElementById("geo-retailer-map");
        const bounds = new google.maps.LatLngBounds();

        this.markers.forEach((marker) => {
            if (marker.position) {
                bounds.extend(marker.position);
            }
        });

        // Fit bounds only if more than 1 marker
        if (this.markers.length > 1) {
            this.map.fitBounds(bounds);
        } else if (this.markers.length === 1) {
            // Set center and min zoom manually for single marker
            this.map.setCenter(this.markers[0].position);
            this.map.setZoom(12); // <- adjust this to your desired minimum zoom level
        }

        mapContainer.classList.remove("hidemap");
    }

    __openInfoWindowById(id) {
        if (this.markerInfoMap[id]) {
            const { marker, infoWindow } = this.markerInfoMap[id];
            // Close all other info windows
            Object.values(this.markerInfoMap).forEach(({ infoWindow }) => {
                if (infoWindow.getMap()) {
                    infoWindow.close();
                }
            });
            // Open the requested info window
            infoWindow.open(this.map, marker);
        } else {
            console.error(`No marker found with ID: ${id}`);
        }
    }

    __addStartingLocationPin(lat, lng) {
        if (!this.map || !this.PinElement) {
            console.warn("Map or PinElement not ready yet.");
            return;
        }

        // Create a starting location pin, using native pin
        // const pinBackground = new this.PinElement({
        //     background: "var(--secondary)",
        //     borderColor: "#FFFFFF",
        //     glyphColor: "#FFFFFF",
        //     scale: 1.2,
        // });

        const parser = new DOMParser();
        const pinSvgString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24.74" height="29.74" viewBox="0 0 24.74 29.74"><defs><filter id="Path_8501" x="0" y="0" width="24.74" height="29.74" filterUnits="userSpaceOnUse"><feOffset dy="1" input="SourceAlpha"/><feGaussianBlur stdDeviation="1" result="blur"/><feFlood flood-opacity="0.102"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter></defs><g id="Group_1224" data-name="Group 1224" transform="translate(17663 17147)"><g transform="matrix(1, 0, 0, 1, -17663, -17147)" filter="url(#Path_8501)"><path id="Path_8501-2" data-name="Path 8501" d="M124.023,54.728a9.37,9.37,0,0,0-9.37,9.37c0,7.182,9.37,14.371,9.37,14.371s9.37-7.189,9.37-14.371A9.37,9.37,0,0,0,124.023,54.728Z" transform="translate(-111.65 -52.73)" fill="#fff"/></g><path id="Path_8500" data-name="Path 8500" d="M124.023,54.728a9.37,9.37,0,0,0-9.37,9.37c0,7.182,9.37,14.371,9.37,14.371s9.37-7.189,9.37-14.371A9.37,9.37,0,0,0,124.023,54.728Zm0,13.847A4.477,4.477,0,1,1,128.5,64.1,4.477,4.477,0,0,1,124.023,68.575Z" transform="translate(-17774.652 -17199.729)" fill="var(--secondary)" stroke="var(--secondary)" stroke-width="0.1"/></g></svg>`;
        const pinSvg = parser.parseFromString(pinSvgString, "image/svg+xml").documentElement;

        const startMarker = new this.AdvancedMarkerElement({
            position: { lat, lng },
            map: this.map,
            title: "Starting Location",
            content: pinSvg,
        });

        // Store separately if needed later
        this.startingPin = startMarker;
    }
}
